import { Link } from 'react-router-dom';

// 404 без пустого белого экрана: понятный текст и путь назад.
export function NotFound() {
  return (
    <main className="mnc-page">
      <section className="mnc-card" style={{ cursor: 'default', textAlign: 'center' }}>
        <h1>Страница не найдена</h1>
        <p className="mnc-muted">Такого салона или адреса нет.</p>
        <Link className="mnc-btn" to="/">
          На главную
        </Link>
      </section>
    </main>
  );
}
